import { render, staticRenderFns } from "./DoctorInvoices.vue?vue&type=template&id=3f67e886&scoped=true"
import script from "./DoctorInvoices.vue?vue&type=script&lang=js"
export * from "./DoctorInvoices.vue?vue&type=script&lang=js"
import style0 from "./DoctorInvoices.vue?vue&type=style&index=0&id=3f67e886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f67e886",
  null
  
)

export default component.exports